import { tns } from 'tiny-slider/src/tiny-slider';

class AlaskanLifeTestimonialsSlider {
	constructor(el, prevButton, nextButton) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;

		const alaskanLifeTestimonialsSlider = tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: "carousel",
			autoplay: true,
			autoplayButtonOutput: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton
		});

		this.normalizeSlides();
		alaskanLifeTestimonialsSlider.events.on('transitionStart', () => this.normalizeSlides());
		window.addEventListener('resize', () => this.normalizeSlides());

		return alaskanLifeTestimonialsSlider;
		
	}

	normalizeSlides() {
		const slides = this.el.querySelectorAll('.block-alaskan-life-testimonials__testimonial-slide');
		slides.forEach((slide) => {
			slide.setAttribute('style', '');
		});

		let maxHeight = 0;
		slides.forEach((slide) => {
			const slideHeight = slide.clientHeight;
			if(slideHeight > maxHeight) {
				maxHeight = slideHeight;
			}
		});

		slides.forEach((slide) => {
			slide.setAttribute('style', 'height: ' + maxHeight + 'px');
		});
	}
}

export default AlaskanLifeTestimonialsSlider;